import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    hideWhenInstalled: { type: Boolean, default: true }
  }

  connect() {
    if (this.hideWhenInstalledValue && this.isInstalledPwa()) {
      this.hideElement()
    }
  }

  isInstalledPwa() {
    const standaloneDisplayMode =
      typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches
    const iosStandalone = window.navigator.standalone === true
    const androidTrustedWebApp = document.referrer.startsWith("android-app://")

    return standaloneDisplayMode || iosStandalone || androidTrustedWebApp
  }

  hideElement() {
    this.element.classList.add("d-none")
    this.element.setAttribute("aria-hidden", "true")
  }
}
